import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _get from "lodash/get";
import { createAsyncAction } from "./utils";
import { creditCards } from "../constants/urls";
export var getOffers = createAsyncAction('getOffers', function (_ref) {
  var _ref$payload = _ref.payload,
      payload = _ref$payload === void 0 ? {} : _ref$payload,
      _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? {} : _ref$meta;
  return {
    meta: meta,
    makeRequest: function makeRequest(state, opts) {
      return new Promise(function (resolve, reject) {
        opts.ServiceSDK.http({
          method: 'POST',
          json: payload,
          headers: {
            'Content-Type': 'application/json',
            'X-Caller-Client-ID': process.env.CLIENT_ID
          },
          url: "".concat(process.env.NERDWALLET_API_BASE_URL).concat(creditCards.offer_api),
          params: {
            client_id: process.env.CLIENT_ID
          },
          cookies: {},
          callback: function callback(err, res, data) {
            if (_get(res, 'statusCode') === 200) {
              resolve(data);
            } else {
              reject(err);
            }
          },
          timeout: 10000
        });
      });
    }
  };
});